import React from 'react';

export default function MagicWandSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      {/* Sparkle particles */}
      <path d="M12 6L13 4L14 6L13 8Z" fill="#FFD700" opacity="0.5" />
      <path d="M8 10L9 9L10 10L9 11Z" fill="#FFD700" opacity="0.4" />
      <path d="M16 12L17 11L18 12L17 13Z" fill="#FFD700" opacity="0.3" />
      <circle cx="10" cy="4" r="0.8" fill="#FFD700" opacity="0.4" />
      <circle cx="18" cy="8" r="0.6" fill="#FFD700" opacity="0.3" />
      {/* Wand shaft */}
      <line x1="14" y1="14" x2="32" y2="36" stroke="#6B3FA0" strokeWidth="3" strokeLinecap="round" />
      {/* Wand shaft highlight */}
      <line x1="15" y1="15" x2="31" y2="35" stroke="#8B5FC0" strokeWidth="1.5" strokeLinecap="round" />
      {/* Shaft bands */}
      <line x1="20" y1="21" x2="22" y2="23" stroke="#D4A830" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="24" y1="26" x2="26" y2="28" stroke="#D4A830" strokeWidth="1.5" strokeLinecap="round" />
      {/* Star tip */}
      <path d="M13 8L14 12L10 14L14 16L13 20L16 17L20 18L17 15L18 11L15 13Z" fill="#FFD700" />
      {/* Star inner glow */}
      <circle cx="15" cy="14" r="3" fill="#FFE880" opacity="0.5" />
      <circle cx="15" cy="14" r="1.5" fill="white" opacity="0.4" />
      {/* Handle end */}
      <circle cx="32" cy="36" r="2" fill="#6B3FA0" />
      <circle cx="32" cy="36" r="1" fill="#D4A830" />
    </svg>
  );
}
